import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";

export const SharedBlipPage = () => {
  const { blipId } = useParams<{ blipId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (blipId) {
      // Redirect to the main feed with the specific blip
      navigate(`/blips?id=${blipId}`, { replace: true });
    } else {
      // If no blipId, redirect to main feed
      navigate("/blips", { replace: true });
    }
  }, [blipId, navigate]);

  // Show a loading state while redirecting
  return (
    <div className="w-full h-screen flex items-center justify-center bg-[#F4F4F4]">
      <div className="flex flex-col items-center gap-4">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-[#16783A]" />
        <p className="text-gray-600 text-sm">Loading blip...</p>
      </div>
    </div>
  );
};
